import request from '@/utils/request'
export function getDynamic(lang) {
  return request({
    url: '/app-api/website/dynamic/list',
    method: 'get'
  })
}
